import {Controller} from "stimulus"

class ParentController extends Controller {
}

export {ParentController}
